import { useState, useEffect } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import FilterSingleSelectDropdown from "../../components/filterDropdown/FilterSingleSelectDropdown";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function MissingInventoryViewModel(logout) {
  const defaultFilters = {
    warehouse_location: { value: -1, label: "All locations" },
    product_data: { value: -1, label: "All PLUs" },
    class: { value: -1, label: "All Classes" },
    category: { value: -1, label: "All categories" },
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [pluOptions, setpluOptions] = useState(false);
  const [classTypeOptions, setClassTypeOptions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [warehouseLocations, setWarehouseLocations] = useState(false);

  const getMissingInventory = async function (search, filter) {
    setLoading(true);
    const payload = {
      search: search,
      filter: filter,
    };
    let callResult = await makePostApiCall(`getMissingCartonsOnly`, payload);
    setLoading(false);
    if (callResult.success) {
      setProducts(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getAllPlus = async function () {
    let callResult = await makeGetApiCall(`productsForDropdown`);
    if (callResult.success) {
      setpluOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getWarehouseLocations = async function () {
    let callResult = await makeGetApiCall(`warehouseLocationsForDropdown/2`);
    if (callResult.success) {
      setWarehouseLocations(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getClassTypes = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall("classesForDropdown");
    setLoading(false);
    if (callResult.success) {
      setClassTypeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch class types");
    }
  };

  const getCategoryTypes = async function () {
    if (filters.class.value === -1) {
      return;
    }
    let callResult = await makeGetApiCall(`categoriesForDropdownWithClass/${filters.class.value}`);
    if (callResult.success) {
      setCategories([
        { value: -1, label: "All categories" },
        ...callResult.data,
      ]);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch category types");
    }
  };

  useEffect(() => {
    if (filters.class.value === -1) {
      setCategories([{ value: -1, label: "All categories" }]);
    } else {
      getCategoryTypes();
    }
  }, [filters.class.value]);

  const filterComponents = [
    <FilterSingleSelectDropdown
      header="PLU"
      onChange={(value) =>
        setFilters({
          ...filters,
          product_data: value,
        })
      }
      options={pluOptions}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="plu"
      value={filters.product_data}
    />,
    <FilterSingleSelectDropdown
      header="Class"
      onChange={(value) =>
        setFilters({
          ...filters,
          class: value,
        })
      }
      options={classTypeOptions}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="class"
      value={filters.class}
    />,
    <FilterSingleSelectDropdown
      header="Category"
      onChange={(value) =>
        setFilters({
          ...filters,
          category: value,
        })
      }
      options={categories}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="category"
      value={filters.category}
      disabled={filters.class.value === -1}
    />,
    <FilterSingleSelectDropdown
      header="Location"
      onChange={(value) =>
        setFilters({
          ...filters,
          warehouse_location: value,
        })
      }
      options={warehouseLocations}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="warehouse_location"
      value={filters.warehouse_location}
    />,
  ];

  const resetFilters = () => {
    setFilters(defaultFilters);
    setShowFilters(false);
    getMissingInventory(1, defaultFilters);
  };

  return {
    getMissingInventory,
    products,
    loading,
    emptyModal,
    filterComponents,
    pluOptions,
    classTypeOptions,
    categories,
    warehouseLocations,
    resetFilters,
    getWarehouseLocations,
    getClassTypes,
    getCategoryTypes,
  };
}
